import { Dispatch } from 'redux';
import { ClientContextType } from '../contexts/Client/types';
import { ClientReducerActionType } from '../reducers/clientReducer';

// Types des actions sur le client
export const FETCH_CLIENT = 'fetch_client';

export const fetchClient =
  (client: ClientContextType) =>
  async (dispatch: Dispatch<ClientReducerActionType>) => {
    dispatch({ type: FETCH_CLIENT, payload: client });
  };
